import React, { Component } from "react";
import './Feedback.css';

class Feedback extends Component {
	render() {
		return (
			<div className="feedback-content">
				{/*<div className="content" >*/}
					<div  className="main-feedback-title"> 
						{/*<big><big>По всем вопросам, пожеланиям и отзывам</big></big>*/}
						<big><big><big>Напиши нам Ваши вопросы, предложения и пожелания</big></big></big>
						<br /><br />
						<big><big>Будем рады видеть Вас в нашем канале&emsp;<a href="https://t.me/nakopiclub">t.me/nakopiclub</a> </big></big>
						<br />
						<big><big>Или получить от Вас электронное письмо </big> <em>support@nakopi.club</em></big>
						{/*телеграм канала - https://t.me/nakopiclub */}
						
					</div>
				{/*</div>*/}
			</div>
		)
	}
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/views/Feedback/Feedback.jsx